"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const common_1 = require("../common");
const moment_1 = __importDefault(require("moment"));
const api_1 = __importDefault(require("../api"));
const types_1 = require("../../types");
const show_add_client_modal = () => {
    web_ui_1.ModalHelper.once('shown', () => __awaiter(void 0, void 0, void 0, function* () {
        const first_name_field = web_ui_1.ModalHelper.select('#add_client_first_name');
        const last_name_field = web_ui_1.ModalHelper.select('#add_client_last_name');
        const mobile_field = web_ui_1.ModalHelper.select('#add_client_mobile');
        const dob_field = web_ui_1.ModalHelper.select('#add_client_dob');
        const secret_field = web_ui_1.ModalHelper.select('#add_client_secret');
        const button = web_ui_1.ModalHelper.select('#add_client_save');
        secret_field.on('change keyup', event => {
            return (0, common_1.checkSSN)((0, web_ui_1.$)(event.target));
        });
        dob_field.on('change keyup', event => {
            return (0, common_1.checkDate)((0, web_ui_1.$)(event.target));
        });
        button.on('click', () => __awaiter(void 0, void 0, void 0, function* () {
            const first_name = first_name_field.val().trim();
            const last_name = last_name_field.val().trim();
            const mobile = mobile_field.val().trim();
            const secret = secret_field.val().trim();
            const _dob = dob_field.val().trim();
            if (_dob.length === 0) {
                return dob_field.addClass('is-invalid');
            }
            else {
                dob_field.removeClass('is-invalid');
            }
            const dob = moment_1.default.utc(_dob);
            if (dob.isBefore('1899-12-31')) {
                return dob_field.addClass('is-invalid');
            }
            if (!secret.match(/[0-9]{9}/)) {
                return secret_field.addClass('is-invalid');
            }
            else {
                secret_field.removeClass('is-invalid');
            }
            try {
                web_ui_1.LoadingOverlay.show();
                const result = yield api_1.default.updateClient({
                    first_name,
                    last_name,
                    mobile,
                    ssn: secret,
                    birthday: dob.toDate()
                });
                if (result === types_1.HTTPError.CREATED) {
                    (0, web_ui_1.$)('#staff-portal-card').trigger('refresh');
                    return web_ui_1.ModalHelper.close();
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'Invalid Credentials Supplied',
                    body: 'Please check your information and try again'
                });
            }
            catch (_a) {
                web_ui_1.LoadingOverlay.hide();
            }
        }));
    }));
    web_ui_1.ModalHelper.open({
        title: 'Add New Client',
        body: (0, web_ui_1.$)('#add_client_modal').clone()
            .removeClass('d-none')
    });
};
exports.default = show_add_client_modal;
